export default __webpack_public_path__ + "static/media/people.7c7c7175.svg";